import React from 'react';
import {
  checkProduct,
  getPayInMethodTitle,
  toCurrency,
  calculateExchangeRate,
} from '@common/utils';
import { useSelector } from 'react-redux';

const EaPlanInfo = props => {
  const {
    planMainInfo,
    mainContractInfo,
    riderContractInfo,
    isPlanViewMore,
    setIsPlanViewMore,
    isUsdPlan,
  } = props;

  const { productDetail } = useSelector(state => state.omniReducer);
  const exchangeRate = productDetail?.exchangeRate;
  const isExchangeRateExist = !$utils.isEmptyString(exchangeRate);

  // 원단위 표기를 위한 특약코드목록
  const subProductCode = [
    '907600', // 무배당 장기요양(1~5등급)보험료지원특약(올페이백형)ll
    '808601', // 암페이특약 1종 (일반심사형)
    '808602', // 암페이특약 2종 (간편심사형)
    '907800', // 3대질병50% 장해보험료지원특약(표준형)
    '907801', // 보험료지원특약 2종(암진단)(일반심사형)
    '907802', // 보험료지원특약 3종(암진단)(간편심사형)
  ];

  return (
    <>
      <div className="con-wrap bg-gray">
        <div className="app-wrap">
          <div className="app-box summary-pro-box">
            <div className="summary-pro">
              <strong>
                {planMainInfo.mainProductName}
                {riderContractInfo.length > 0 && (
                  <span>외 특약 {riderContractInfo.length}종</span>
                )}
              </strong>
            </div>
            <div className="summary-fee">
              <em>전체 {getPayInMethodTitle(planMainInfo.payinMethod)}</em>
              <strong className="number">
                {!isUsdPlan
                  ? toCurrency(planMainInfo.premium)
                  : toCurrency(planMainInfo.premium, 2)}
              </strong>
              <span className="txt">{!isUsdPlan ? '원' : '달러'} </span>

              {isUsdPlan && isExchangeRateExist && (
                <div className="exchange-rate">
                  {`${calculateExchangeRate(
                    planMainInfo.premium,
                    exchangeRate,
                  )}원`}
                  <span>{`(오늘기준환율 ${exchangeRate}원/달러)`}</span>
                </div>
              )}
            </div>
          </div>

          <div className="app-box detail-open">
            <div className="tit-area">
              <h2 className="tit-con mgt-0">주계약</h2>
              <span
                className={`${isPlanViewMore ? 'btn-close' : 'btn-open'}`}
                onClick={() => setIsPlanViewMore(!isPlanViewMore)}
              ></span>
            </div>
            <ul className="summary-head">
              <li>상품명</li>
              <li>{getPayInMethodTitle(planMainInfo.payinMethod)}</li>
            </ul>
            <ul className="summary-con">
              <li>
                <div className="summary-insu">
                  <strong className="insu-name">
                    {mainContractInfo.map(data => data.productName)}
                  </strong>
                  <div className="box-info-insu">
                    <span className="number">
                      {!isUsdPlan
                        ? mainContractInfo.map(data => toCurrency(data.premium))
                        : mainContractInfo.map(data =>
                            toCurrency(data.premium, 2),
                          )}
                    </span>
                    <span className="txt">{!isUsdPlan ? '원' : '달러'} </span>

                    {isUsdPlan && isExchangeRateExist && (
                      <div className="exchange-rate">
                        {`${calculateExchangeRate(
                          mainContractInfo.map(data => data.premium),
                          exchangeRate,
                        )}원`}
                        <span>{`(오늘기준환율 ${exchangeRate}원/달러)`}</span>
                      </div>
                    )}
                  </div>
                </div>
                {isPlanViewMore && (
                  <div className="amount-info">
                    <span>보험가입금액</span>
                    <strong className="input-under fee">
                      {!isUsdPlan
                        ? mainContractInfo.map(data =>
                            toCurrency(data.faceAmount),
                          ) + '만원'
                        : mainContractInfo.map(data =>
                            toCurrency(data.faceAmount),
                          ) + '달러'}
                    </strong>
                    <span>보험기간</span>
                    <strong className="input-under">
                      {mainContractInfo.map(
                        data => data.coveragePeriodInfoLabel,
                      )}
                    </strong>
                    <span>납입기간</span>
                    <strong className="input-under">
                      {mainContractInfo.map(data => data.payinPeriodInfoLabel)}
                    </strong>
                  </div>
                )}
              </li>
            </ul>

            {riderContractInfo.length > 0 && (
              <>
                <div className="tit-area">
                  <h2 className="tit-con mgt-0">특약</h2>
                </div>
                <ul className="summary-head">
                  <li>상품명</li>
                  <li>{getPayInMethodTitle(planMainInfo.payinMethod)}</li>
                </ul>
                <ul className="summary-con">
                  {riderContractInfo.map((data, index) => {
                    return (
                      <li key={index}>
                        <div className="summary-insu">
                          <strong className="insu-name">
                            {data.productName}
                          </strong>
                          <div className="box-info-insu">
                            <span className="number">
                              {!isUsdPlan
                                ? toCurrency(data.premium)
                                : toCurrency(data.premium, 2)}
                            </span>
                            <span className="txt">
                              {!isUsdPlan ? '원' : '달러'}
                            </span>

                            {isUsdPlan && isExchangeRateExist && (
                              <div className="exchange-rate">
                                {`${calculateExchangeRate(
                                  data.premium,
                                  exchangeRate,
                                )}원`}
                                <span>{`(오늘기준환율 ${exchangeRate}원/달러)`}</span>
                              </div>
                            )}
                          </div>
                        </div>
                        {isPlanViewMore && (
                          <div className="amount-info">
                            <span>보험가입금액</span>
                            <strong className="input-under fee">
                              {!isUsdPlan
                                ? subProductCode.includes(
                                    String(data.productCode).substring(0, 6),
                                  )
                                  ? toCurrency(data.faceAmount) + '원'
                                  : toCurrency(data.faceAmount) + '만원'
                                : toCurrency(data.faceAmount) + '달러'}
                            </strong>
                            <span>보험기간</span>
                            <strong className="input-under">
                              {data.coveragePeriodInfoLabel}
                            </strong>
                            <span>납입기간</span>
                            <strong className="input-under">
                              {data.payinPeriodInfoLabel}
                            </strong>
                          </div>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EaPlanInfo;
